export default class NumberFormat {

	static regex = {
		onlyNumbers: /[^0-9.]/gi,
		isNumbers: /^[0-9.]+$/gi
	}

	static checkIsNumber(value: string | number): boolean {
		return !!String(value).match(NumberFormat.regex.isNumbers);
	}

	static getOnlyNumbers(value: string | number): string {
		return String(value).replace(NumberFormat.regex.onlyNumbers, '');
	}

	static format(v: number, fractionDigits: number = 2): string {
		let value: string = Number(v.toFixed(fractionDigits))
			.toLocaleString('ru')
			.replace(',', '.');

		let [ mainValue, subValue ] = value.split('.');

		subValue = subValue || '';

		return mainValue + '.' + subValue + '0'.repeat(fractionDigits - subValue.length);
	}

	static divideAndFormat(v?: number | null, fractionDigits: number = 2): string {
		return NumberFormat.format(
			(v || 0) / Math.pow(10, fractionDigits || 1),
			fractionDigits
		);
	}

	static fixNum(v: number, fractionDigits: number = 2): number {
		let [ amountMain, amountSub ] = String(v).split('.');

		amountSub = (amountSub || '').slice(0, fractionDigits);

		if (amountSub.length < fractionDigits)
			amountSub += '0'.repeat(fractionDigits - amountSub.length);

		return Number(amountMain + amountSub);
	}

	static fixNumWithRound(v: number, fractionDigits: number = 2): number {
		let rounded = v.toFixed(fractionDigits);

		let [amountMain, amountSub] = rounded.split('.');

		if (amountSub.length < fractionDigits)
			amountSub += '0'.repeat(fractionDigits - amountSub.length);

		return Number(amountMain + amountSub);
	}

	static withZero(value: number): string {
		return value > 9 ? value.toString() : '0' + value;
	}

}